<template>
  <div class="flex h-full w-full flex-col p-6 sm:p-12">
    <UiButton
      v-if="!isDesktop"
      :outlined="false"
      variant="text"
      flat
      class="mb-8 uppercase"
      @click="close"
    >
      <span class="mr-2 h-4 w-4">
        <UiIcon icon="chevronLeft" container-size />
      </span>

      {{ $t('back') }}
    </UiButton>

    <UiSearchForm v-model="searchValue" @search="doSearch" />

    <UiSearchFormPopularQueries
      :items="popularSearches"
      class="mt-8 md:mt-12"
      @update:model-value="selectSearchResult"
    />
  </div>
</template>

<script setup lang="ts">
import { useBreakpoint, useSearch } from '~/composables';

interface Emits {
  (e: 'close'): void;
  (e: 'search', value: string): void;
}

const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');
const {
  searchValue,
  popularSearches,
  searchType,
  searchProducts,
  searchDocuments,
  updateRouter,
} = useSearch();

const emit = defineEmits<Emits>();

const close = () => emit('close');

const doSearch = async () => {
  if (!searchValue.value) return;
  close();

  if (searchType.value) updateRouter(searchType.value);
  else
    searchType.value === 'documents'
      ? await searchDocuments()
      : await searchProducts();
};

const selectSearchResult = (value: string) => {
  searchValue.value = value;
  doSearch();
};
</script>
